import type { Meta, StoryObj } from "@storybook/react";

import type { NavigationIconButtonProps } from "@/ui/core";
import { NavigationIconButton } from "@/ui/core";
import type { NavigationButtonType } from "@/ui/core/buttons/NavigationIconButton";

const NavigationIconButtonValues: Record<
  NavigationButtonType,
  NavigationButtonType
> = {
  back: "back",
  close: "close",
};

const StoryMeta: Meta<NavigationIconButtonProps> = {
  title: "Core/Navigation Icon Button",
  component: NavigationIconButton,
  argTypes: {
    onPress: { action: "navigation icon button pressed" },
    type: {
      control: "select",
      options: Object.values(NavigationIconButtonValues),
    },
  },
};

type Story = StoryObj<NavigationIconButtonProps>;

const Back: Story = {
  args: { type: "back" },
};

const Close: Story = {
  args: { type: "close" },
};

export { Back, Close };
export default StoryMeta;
